import { CTRItem } from '~bank-bsa-reporting/types'

export interface CTRListProps {
  items: CTRItem[]
}
